import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import { CloseButton, Flex, Paper, Space, Text } from '@mantine/core';

interface MultiSelectValueProps extends ComponentPropsWithoutRef<'div'> {
  label: string;
  value: string;
  classNames: Partial<Record<'defaultValue' | 'defaultValueRemove' | 'defaultValueLabel', string>> | undefined;
  onRemove(): void;
  iconComponent: ReactNode;
}

// Destructure classNames out to prevent React warnings.
// classNames is used by Mantine to style the component (MutliSelect component).
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function MultiSelectValue({ label, onRemove, iconComponent, classNames, ...others }: MultiSelectValueProps) {
  return (
    <Paper withBorder {...others} p={3} pl={9}>
      <Flex direction="row" align="center">
        {iconComponent}
        <Space w={5} />
        <Text>{label}</Text>
        <Space w={5} />
        <CloseButton onMouseDown={onRemove} variant="transparent" size={14} iconSize={14} tabIndex={-1} />
      </Flex>
    </Paper>
  );
}
